import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const GroupService = {
    list: () => axios.post(API_URL + "/group/list").then(({ data: {data} }) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_URL + "/group/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_URL + "/group", data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (id, data) => axios.post(API_URL + "/group/" + id, data).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_URL + "/group/" + id).catch((err) => { throw err }),

    occurrenceGroup: async () => axios.get(API_URL + "/group/occurrence-options/byUser").then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    getOptions: async (module = "all") => axios.get(API_URL + `/group/options/${module}`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    getOptionsMyUser: async (module = "all") => axios.get(API_URL + `/group/options/${module}/by-user`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
}

export default GroupService;